module.exports = __webpack_public_path__ + "img/es.3d0c624c.svg";